const cookieExpBegin = '(?:(?:^|.*;\\s*)';
const cookieExpEnd = '\\s*\\=\\s*([^;]*).*$)|^.*$';

module.exports = {
	get: function (key) {
		let cookieRegExp = new RegExp(cookieExpBegin + key + cookieExpEnd);
		let value = document.cookie.replace(cookieRegExp, '$1');

		if (value === '') {
			value = void 0;
		}

		return value;
	},

	set: function (pairs, value) {
		if (typeof pairs === 'string') {
			var temp = pairs;

			pairs = {};

			pairs[temp] = value;
		}

		var changed = [];

		for (var k in pairs) {
			let kVal = this.get(k);
			if (!kVal || kVal !== pairs[k]) {
				changed.push({
					key: k,
					value: pairs[k]
				});
			}

			document.cookie = k + '=' + pairs[k] + '; Path=/;';
		}

		return changed;
	},

	remove: function (key) {
		let value = this.get(key);
		let changed = value !== null && typeof value !== 'undefined';

		document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/;';

		return changed;
	}
};
